module.exports = __webpack_public_path__ + "img/127.df973c6c.jpg";